import { useState, useCallback } from 'react';
import type { FieldDiaryEntry } from '../types';

type ModalStep = 'closed' | 'nota' | 'viewNota';

export const useInsertionFlow = () => {
	const [step, setStep] = useState<ModalStep>('closed');
	const [selectedEntry, setSelectedEntry] = useState<FieldDiaryEntry | null>(null);

	const open = useCallback(() => setStep('nota'), []);

	const close = useCallback(() => {
		setStep('closed');
		setSelectedEntry(null);
	}, []);

	const openViewEntry = useCallback((entry: FieldDiaryEntry) => {
		if (entry.type !== 'nota') return;
		setSelectedEntry(entry);
		setStep('viewNota');
	}, []);

	return {
		step,
		selectedEntry,
		open,
		close,
		openViewEntry,
		isNoteOpen: step === 'nota',
		isViewNoteOpen: step === 'viewNota',
	};
};
